import React, { useImperativeHandle, useState, useRef, useEffect, useContext } from "react";
import { Popup, PopupRef, Position, ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from "../../utils/media-query";
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { EmergenzeApi } from "../../data";
import { apiConfiguration } from "../../apiConfig";
import TenantContext from "../../contexts/tenantContext";
import notify from "devextreme/ui/notify";
import { showError } from "../../utils/errorHandling";
import { LoadPanel } from "devextreme-react";
import EmergenzaAssistitoCompletaPanel, { EmergenzaAssistitoCompletaPanelHandle } from "./EmergenzaAssistitoCompletaPanel";

type Props = {
  emergenzaId: string;
  onHidden?: () => void;
  onDataChanged?: () => void;
}

export type EmergenzaAssistitoCompletaPopupHandle = {
  show: (emergenzaAssistitoId:string) => void
}

type state = {
  visible: boolean,
  emergenzaAssistitoId?:string
}

const EmergenzaAssistitoCompletaPopup: React.ForwardRefRenderFunction<EmergenzaAssistitoCompletaPopupHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [state, setState] = useState<state>({ visible: false,emergenzaAssistitoId: undefined });
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const { isXSmall, isSmall } = useScreenSize();
  const [fullscreen, setFullscreen] = useState(isXSmall || isSmall);
  const formRef = useRef<EmergenzaAssistitoCompletaPanelHandle>(null);

  function hide() {
    setState({ visible: false,emergenzaAssistitoId: undefined });
    props.onHidden?.();
  }

  async function SaveAndClose() {
    if (await formRef.current?.save())
      {
      props.onDataChanged?.();
      hide();
    } 
  }

  useImperativeHandle(ref, () => ({
    show(emergenzaAssistitoId:string) {
       setState({
        visible: true,
        emergenzaAssistitoId:emergenzaAssistitoId
      });
    }
  }));

  return (
    <React.Fragment>
      {state.visible &&
        <Popup
          visible={true}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          fullScreen={fullscreen}
          showTitle={true}
          onHidden={hide}
          title="Completa assistenza"
          container=".dx-viewport"
          width={fullscreen ? '100%' : '80%'}
          height={fullscreen ? '100%' : 'auto'}
        >
          <Position
            at="center"
            my="center"
            of=""
            collision="fit"
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="top"
            location="after"
            options={{
              icon: 'fullscreen',
              onClick: () => setFullscreen(!fullscreen),
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Salva',
              type: 'default',
              stylingMode: 'contained',
              onClick: SaveAndClose
            }}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={{
              text: 'Annulla',
              type: 'normal',
              stylingMode: 'contained',
              onClick: hide
            }}
          />

        <EmergenzaAssistitoCompletaPanel ref={formRef} emergenzaAssistitoId={state.emergenzaAssistitoId} />

          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '#form' }}
            visible={loadPanelVisible}
            showIndicator={true}
            shading={false}
            showPane={true}
            hideOnOutsideClick={false}
          />
        </Popup>
      }
    </React.Fragment>
  );
}

export default React.forwardRef(EmergenzaAssistitoCompletaPopup);
